import { saveAs } from 'file-saver';
import { w69b } from 'barcode.js';
import * as JSZip from 'jszip';
import {Promise} from "bluebird";

const createQRCodeImages = () => {
    // 'use strict';

	var Bluebird = Promise;
	var CONCURRENT_QR_CODE_GENERATION = window.navigator.hardwareConcurrency;
	if (!Number.isSafeInteger(CONCURRENT_QR_CODE_GENERATION) || CONCURRENT_QR_CODE_GENERATION < 4) {
		CONCURRENT_QR_CODE_GENERATION = 4;
	}

	function generate_qr_code_image(qrcode) {
		var canvas = window.document.createElement('canvas');
		canvas.width = 200;
		canvas.height = 200;
        
		w69b.qr.encoding.drawOnCanvas(qrcode, canvas, 1);
		return canvas;
	}

	function get_canvas_blob(canvas) {
		return new Promise(function(resolve, reject) {
			try {
				w69b.imgtools.getCanvasAsBlob(canvas, resolve);
			} catch (e) {
				reject(e);
			}
		});
	}

	function trim_line(line) {
		return line.trim();
	}

	function is_non_empty_line(line) {
		return line.length > 0;
	}

	async function generate_qrcode(evt) {
		evt.preventDefault();
		var form_fieldset = window.document.getElementById('form_fieldset');
		var error_message_area = window.document.getElementById('error_message_area');
		try {
			form_fieldset.disabled = true;
			var output_area = window.document.getElementById('output_area');
			output_area.innerHTML = '';
			var input_text = evt.target.elements.input_text;
			var lines = input_text.value.split(/[\r\n]+/).map(trim_line).filter(is_non_empty_line);

			if (lines.length > 0) {
				var count = 1;
				var total = lines.length;
				function show_generate_qr_code_progress() {
					error_message_area.textContent = 'Generating QR code images: ' + count + ' of ' + total;
				}
				show_generate_qr_code_progress();
				var intervalId = window.setInterval(show_generate_qr_code_progress, 1000);
				
				var zip = new JSZip();
				await Bluebird.map(lines, function(line) {
					return get_canvas_blob(generate_qr_code_image(line)).then(function(blob) {
						++count;
						var filename = line;
						try {
							var lineObj = JSON.parse(line);
							filename = lineObj && lineObj.qr_code_display_id || line;
						} catch (e) {
							// console.log(e);
						}
						zip.file(filename + '.png', blob);
						return null;
					});
				}, {
					concurrency: CONCURRENT_QR_CODE_GENERATION
				});
				window.clearInterval(intervalId);
				
				function show_zip_progress(metadata) {
					error_message_area.textContent = 'Zipping QR code images: ' + metadata.percent.toFixed(2) + '%';
				}
				var zip_blob = await zip.generateAsync({
					type: 'blob'
				}, show_zip_progress);
				error_message_area.textContent = 'Saving ZIP file';
				var now = new Date();
				var fileSaver = saveAs(zip_blob, 'qrcode_' + now.toISOString() + '.zip', true);
				// fileSaver.onwriteend = function(fs) {
				// 	error_message_area.textContent = 'Done';
				// };
				// fileSaver.onabort = function(fs) {
				// 	error_message_area.textContent = 'Saving aborted';
				// };
			} else {
				error_message_area.textContent = 'No QR codes';
			}
		} catch (e) {
			window.console.error(e);
			error_message_area.textContent = e;
		}
		form_fieldset.disabled = false;
	}

    var generate_qr_code_form = window.document.getElementById('generate_qr_code_form');
	generate_qr_code_form.addEventListener('submit', generate_qrcode, false);
}

export default createQRCodeImages;